import * as lib from '~/dependencies';

export const Container = lib.styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: flex-start;
`;

export const RowItem = lib.styled.div`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  margin-bottom: 15px;
  margin-left: 20px;
  margin-right: 20px;
`;
